/**
 * Sipsy Age Gate - 21+ Yes/No Verification (90-day cookie)
 *
 * Features:
 * - Simple Yes/No confirmation (no DOB entry)
 * - Fires immediately on DOMContentLoaded (no delay, eliminates CLS)
 * - Only appears to new users or after 90 days
 * - WCAG 2.1 AA compliant (role=dialog, aria-modal, focus trap, error messaging)
 *
 * Updated August 2026: Reverted from DOB entry back to simple Yes/No confirmation.
 * NOTE: The July 2026 DOB version was built specifically to satisfy an SMS/OneText
 * compliance requirement. Confirm with legal/compliance before relying on this
 * simplified Yes/No version if that requirement still applies.
 */

document.addEventListener('DOMContentLoaded', function() {

  (function() {
    'use strict';

    const AGE_GATE_CONFIG = {
      minimumAge: 21,
      cookieName: 'age_verified',
      cookieDays: 90,
      redirectUrl: 'https://www.google.com'
    };

    function getCookie(name) {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
    }

    // Already verified — exit immediately
    if (getCookie(AGE_GATE_CONFIG.cookieName) === 'true') return;

    const html = `
<div id="age-gate-overlay" role="dialog" aria-modal="true" aria-labelledby="age-gate-heading"
     style="position:fixed;top:0;left:0;width:100%;height:100%;
            background:rgba(0,0,0,0.65);z-index:999999;
            display:flex;align-items:center;justify-content:center;
            font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
            backdrop-filter:blur(4px);">
  <div style="background:#ffffff;padding:48px 40px 40px;border-radius:14px;
              max-width:420px;width:90%;text-align:center;
              box-shadow:0 12px 48px rgba(0,0,0,0.25);">

    <img src="https://sipsy.com/cdn/shop/files/sipsy-logo.png" alt="Sipsy" height="36"
         style="margin-bottom:28px;display:block;margin-left:auto;margin-right:auto;"
         onerror="this.style.display='none'">

    <h2 id="age-gate-heading"
        style="margin:0 0 8px;font-size:22px;font-weight:700;color:#122038;">
      Age Verification
    </h2>
    <p style="margin:0 0 28px;font-size:15px;color:#555;line-height:1.55;">
      Are you 21 years of age or older?
    </p>

    <!-- Error message -->
    <p id="ag-error" role="alert" aria-live="assertive"
       style="display:none;color:#c0392b;font-size:13px;margin:0 0 14px;font-weight:600;"></p>

    <!-- Yes / No buttons -->
    <div style="display:flex;gap:12px;margin-bottom:14px;">
      <button id="ag-yes"
              style="background:#122038 !important;color:#ffffff !important;border:none !important;flex:1;
                     padding:16px;font-size:16px;font-weight:700;border-radius:8px;
                     cursor:pointer;letter-spacing:0.02em;transition:opacity 0.2s;">
        Yes, I'm 21+
      </button>
      <button id="ag-no"
              style="background:#ffffff !important;color:#122038 !important;border:2px solid #122038 !important;flex:1;
                     padding:16px;font-size:16px;font-weight:700;border-radius:8px;
                     cursor:pointer;letter-spacing:0.02em;transition:opacity 0.2s;">
        No
      </button>
    </div>

    <p style="font-size:11px;color:#021739 !important;margin:0;line-height:1.5;">
      By entering, you agree you are 21+.
    </p>
  </div>
</div>`;

    document.body.insertAdjacentHTML('beforeend', html);
    document.body.style.overflow = 'hidden';

    const overlay  = document.getElementById('age-gate-overlay');
    const yesBtn   = document.getElementById('ag-yes');
    const noBtn    = document.getElementById('ag-no');
    const errorEl  = document.getElementById('ag-error');

    // Focus first actionable control on open (WCAG 2.4.3)
    yesBtn.focus();

    // Hover feedback
    [yesBtn, noBtn].forEach(function(btn) {
      btn.addEventListener('mouseover', function() { this.style.opacity = '0.85'; });
      btn.addEventListener('mouseout',  function() { this.style.opacity = '1'; });
    });

    // Focus trap (WCAG 2.1.2)
    overlay.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = overlay.querySelectorAll('button');
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });

    yesBtn.addEventListener('click', function() {
      // Verified — set cookie and dismiss
      setCookie(AGE_GATE_CONFIG.cookieName, 'true', AGE_GATE_CONFIG.cookieDays);
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    });

    noBtn.addEventListener('click', function() {
      window.location.href = AGE_GATE_CONFIG.redirectUrl;
    });

  })();

});